var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-deletion-container"},[_c('iframe',{staticClass:"deletion-iframe",attrs:{"src":_vm.deletionUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }